import { render } from "./viewCompliance.vue?vue&type=template&id=8cbe331c&scoped=true&ts=true"
import script from "./viewCompliance.vue?vue&type=script&lang=ts"
export * from "./viewCompliance.vue?vue&type=script&lang=ts"

import "./viewCompliance.vue?vue&type=style&index=0&id=8cbe331c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbe331c"]])

export default __exports__